module.exports = __webpack_public_path__ + "images/emoji/cinema.b02d5abfb14bf6c596cb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cinema.png
// module id = pzj8
// module chunks = 14